module.exports = __webpack_public_path__ + "static/26-400918b91b70cfd4f8736f491516acd6.png";